import { SelectGroup, SelectItem, SelectLabel, SelectSeparator } from '@kalos/ui';
import { Fragment } from 'react';

import { type SubtypeOptionGroup } from '../../../utils/eventTrade';

/**
 * Taller than the 256px popper default so more than one trade group shows without scrolling, capped to
 * the space available. Pair with avoidCollisions={false}: a list this tall would otherwise flip above the field.
 */
// DESIGN-SYSTEM-EXCEPTION: arbitrary max height for a long grouped select; SelectContent has no tall size yet · expires 2027-01-20 · andrew.gaudioso@kalosflorida.com
export const SUBTYPE_SELECT_VIEWPORT_CLASS =
  'max-h-[min(28rem,var(--radix-select-content-available-height))]';

// DESIGN-SYSTEM-EXCEPTION: trade group headers use Steel (ring) text to match the ticket mockup; the system reserves Steel for focus rings · expires 2027-01-20 · andrew.gaudioso@kalosflorida.com
/** Trade group header style; Admin View's MUI select (Field) mirrors it. */
export const SUBTYPE_GROUP_HEADER_CLASS = 'text-ring text-xs font-semibold uppercase tracking-wide';

/** Sub Type options for a @kalos/ui Select, under a non-selectable header per trade group. */
export const SubtypeSelectItems = ({ groups }: { groups: SubtypeOptionGroup[] }) => (
  <>
    {groups.map((group, i) => (
      <Fragment key={group.key}>
        {i > 0 && group.label && <SelectSeparator />}
        <SelectGroup>
          {group.label && (
            <SelectLabel className={SUBTYPE_GROUP_HEADER_CLASS}>{group.label}</SelectLabel>
          )}
          {group.options.map((opt) => (
            <SelectItem key={opt.value} value={String(opt.value)}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </Fragment>
    ))}
  </>
);
